/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { FindMyUserOnboardingStateQueryResponse } from "../types/FindMyUserOnboardingState.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findMyUserOnboardingStateQueryKey = () =>
  [{ url: "/v1/user-onboarding/me" }] as const

export type FindMyUserOnboardingStateQueryKey = ReturnType<
  typeof findMyUserOnboardingStateQueryKey
>

/**
 * @description Supplier portal users only (supplier permission level: SUPPLIER, MANUFACTURER, CERTIFIER, AUDITOR). Returns onboarding progress for the authenticated user. A null state means onboarding has not started.
 * @summary Find current user onboarding state
 * {@link /v1/user-onboarding/me}
 */
export async function findMyUserOnboardingState(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindMyUserOnboardingStateQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/user-onboarding/me`, ...requestConfig })
  return res
}

export function findMyUserOnboardingStateQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findMyUserOnboardingStateQueryKey()
  return queryOptions<
    ResponseConfig<FindMyUserOnboardingStateQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindMyUserOnboardingStateQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findMyUserOnboardingState({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Supplier portal users only (supplier permission level: SUPPLIER, MANUFACTURER, CERTIFIER, AUDITOR). Returns onboarding progress for the authenticated user. A null state means onboarding has not started.
 * @summary Find current user onboarding state
 * {@link /v1/user-onboarding/me}
 */
export function useFindMyUserOnboardingState<
  TData = ResponseConfig<FindMyUserOnboardingStateQueryResponse>,
  TQueryData = ResponseConfig<FindMyUserOnboardingStateQueryResponse>,
  TQueryKey extends QueryKey = FindMyUserOnboardingStateQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindMyUserOnboardingStateQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findMyUserOnboardingStateQueryKey()

  const query = useQuery(
    {
      ...findMyUserOnboardingStateQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
